import { isAufmassPackItem, type Montageunterlage } from "@/lib/projectOverview";

/** Notiz wurde nach dem letzten Montage-Deckblatt-Druck angelegt oder geändert. */
export function noteNeedsReprint(
  item: Pick<Montageunterlage, "entry_type" | "pack" | "created_at" | "updated_at" | "body_text">,
  printedAt: string | null | undefined,
): boolean {
  if (item.entry_type !== "note") return false;
  if (isAufmassPackItem(item)) return false;
  if (!(item.body_text || "").trim()) return false;
  if (!printedAt) return false;
  const stamp = item.updated_at || item.created_at;
  if (!stamp) return true;
  const noteMs = Date.parse(stamp);
  const printMs = Date.parse(printedAt);
  if (Number.isNaN(noteMs) || Number.isNaN(printMs)) return true;
  return noteMs > printMs;
}
